/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PrescriptionCard.vue?vue&type=template&id=1d85a9c6&scoped=true"
import script from "./PrescriptionCard.vue?vue&type=script&lang=js"
export * from "./PrescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionCard.vue?vue&type=style&index=0&id=1d85a9c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85a9c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d85a9c6')) {
      api.createRecord('1d85a9c6', component.options)
    } else {
      api.reload('1d85a9c6', component.options)
    }
    module.hot.accept("./PrescriptionCard.vue?vue&type=template&id=1d85a9c6&scoped=true", function () {
      api.rerender('1d85a9c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/infoview/PrescriptionCard.vue"
export default component.exports